export const CONTACT_EMAIL = 'info@leanc.nl'
export const CONTACT_PHONE = '+31 6 57510445'
export const CONTACT_PHONE_DISPLAY = '06 57510445'
export const COMPANY_NAME = 'LeanC'
export const COMPANY_TAGLINE = 'IT & Web'
export const COMPANY_ADDRESS = 'Statenweg, Rotterdam'
